// A ‘.tsx’ file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
interface FormFieldProps extends ReactProps {
    title: string;
    tooltip?: string;
    inputName: string;
    className?: string;
}

const FormField = (props: FormFieldProps) => (
    <div className={`form-field ${props.className ? props.className : ""}`}>
        <label htmlFor={props.inputName} className="control-label">{props.title}</label>
        {props.tooltip ? <div className='tooltip-container'>
            <span className="tooltip-icon glyphicon glyphicon-question-sign"></span>
            <div className='tooltip-text'>{props.tooltip}</div>
        </div> : null}
        <div className="fr-margin">
            { props.children }
        </div>
    </div>
);

export default FormField;